module.exports = __webpack_public_path__ + "img/desconto_chinamaster.d6b9f4dd.jpg";